import React, { memo, useEffect } from "react";
import { useFormik } from "formik";

import { Error, CustomSelect, Label, Button } from "../";
import { useFilteredData } from "../../Hooks";

const Filter = ({
  isSport = false,
  isTournament = false,
  isMatch = false,
  allMatch = false,
  isEvent = false,
  handleFilterParams = () => {},
  apiParam,
  defaultParams = {},
  isType = false,
  marketTypeData = [],
}) => {
  const eventOptions = [
    { label: "BetFair", value: "1" },
    { label: "Radhe", value: "2" },
  ];

  const { values, touched, errors, handleSubmit, setFieldValue, resetForm } =
    useFormik({
      initialValues: {
        sports: null,
        tournament: null,
        match: null,
        marketType: null,
        event: eventOptions[0],
      },
      enableReinitialize: true,
      onSubmit: async (values) => {
        handleFilterParams(values);
      },
    });

  const { sportOptions, tournamentOptions, matchAllOptions } = useFilteredData({
    sport: values?.sports?.value,
    tournament: values?.tournament?.value,
    dependantMatch: isMatch,
    allMatch,
    enableTournament: isTournament,
    apiParam,
  });

  useEffect(() => {
    // Handle default sportId
    if (
      defaultParams.sportId &&
      sportOptions?.length > 0 &&
      !values.sports?.value
    ) {
      const selectedSport = sportOptions.find(
        (option) => option.value == defaultParams.sportId,
      );

      if (selectedSport) {
        setFieldValue("sports", selectedSport);
      }
    }

    // Handle default tournamentId
    if (
      defaultParams.tournamentId &&
      tournamentOptions?.length > 0 &&
      !values.tournament?.value
    ) {
      const selectedTournament = tournamentOptions.find(
        (option) => option.value == defaultParams.tournamentId,
      );

      if (selectedTournament) {
        setFieldValue("tournament", selectedTournament);
      }
    }

    // Handle default matchId
    if (
      defaultParams.matchId &&
      matchAllOptions?.length > 0 &&
      !values.match?.value
    ) {
      const selectedMatch = matchAllOptions.find(
        (option) => option.value == defaultParams.matchId,
      );

      if (selectedMatch) {
        setFieldValue("match", selectedMatch);
      }
    }
  }, [
    defaultParams.sportId,
    defaultParams.tournamentId,
    defaultParams.matchId,
    sportOptions,
    tournamentOptions,
    matchAllOptions,
    setFieldValue,
    values.sports,
    values.tournament,
    values.match,
  ]);

  const handleClear = () => {
    resetForm({
      values: {
        sports: null,
        tournament: null,
        match: null,
        marketType: null,
        event: eventOptions[0],
      },
    });

    setFieldValue("sports", null);
    setFieldValue("tournament", null);
    setFieldValue("match", null);
    setFieldValue("marketType", null);
    setFieldValue("event", eventOptions[0]);

    handleFilterParams({
      sports: null,
      tournament: null,
      match: null,
      marketType: null,
      event: eventOptions[0],
    });
  };

  return (
    <form className="filter_tableBox" onSubmit={handleSubmit}>
      <div className="row align-items-end">
        {isSport && (
          <div className="col-xl-2 col-lg-3 col-12">
            <div className="input_control">
              <Label htmlFor="sports" className="form-label">
                Sports <span className="text-danger">*</span>
              </Label>
              <CustomSelect
                options={sportOptions}
                value={values.sports}
                onChange={(selectedOption) =>
                  setFieldValue("sports", selectedOption)
                }
                placeholder="Select Sports"
                isMulti={false}
              />
              {errors.sports && touched.sports && (
                <Error>{errors.sports}</Error>
              )}
            </div>
          </div>
        )}
        {isEvent && (
          <div className="col-xl-2 col-lg-3 col-12">
            <div className="input_control">
              <Label htmlFor="event" className="form-label">
                Event <span className="text-danger">*</span>
              </Label>
              <CustomSelect
                options={eventOptions}
                value={values.event}
                onChange={(selectedOption) =>
                  setFieldValue("event", selectedOption)
                }
                placeholder="Select Event"
                isMulti={false}
              />
              {errors.event && touched.event && <Error>{errors.event}</Error>}
            </div>
          </div>
        )}

        {isTournament && (
          <div className="col-xl-2 col-lg-3 col-12">
            <div className="input_control">
              <Label htmlFor="tournament" className="form-label">
                Tournament <span className="text-danger">*</span>
              </Label>
              <CustomSelect
                options={tournamentOptions}
                value={values.tournament}
                onChange={(selectedOption) =>
                  setFieldValue("tournament", selectedOption)
                }
                placeholder="Select Tournament"
                isMulti={false}
              />
              {errors.tournament && touched.tournament && (
                <Error>{errors.tournament}</Error>
              )}
            </div>
          </div>
        )}

        {allMatch && (
          <div className="col-xl-2 col-lg-3 col-12">
            <div className="input_control">
              <Label htmlFor="match" className="form-label">
                Matches <span className="text-danger">*</span>
              </Label>
              <CustomSelect
                options={matchAllOptions}
                value={values.match}
                onChange={(selectedOption) =>
                  setFieldValue("match", selectedOption)
                }
                placeholder="Select Match"
                isMulti={false}
              />
              {errors.match && touched.match && <Error>{errors.match}</Error>}
            </div>
          </div>
        )}

        {isType && marketTypeData && (
          <div className="col-lg-2 col-md-6 col-12 ">
            <div className="input_control">
              <Label htmlFor="marketType" className="form-label">
                Type <span className="text-danger">*</span>
              </Label>
              <CustomSelect
                options={marketTypeData}
                value={values.marketType}
                onChange={(selectedOption) =>
                  setFieldValue("marketType", selectedOption)
                }
                placeholder="Select marketType"
                isMulti={false}
              />
            </div>
          </div>
        )}

        <div className="col-xl-2 col-lg-3 col-12 ">
          <div className="btn_box">
            <Button type="submit" className="btn_submit">
              {" "}
              Search
            </Button>
            <Button type="button" className="btn_clear" onClick={handleClear}>
              Clear
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default memo(Filter);
